import React, { useEffect, useRef, useState } from 'react';
import { Container } from 'semantic-ui-react';

const SliderContent = ({
  title,
  introContent,
  cta,
  ctaAriaLabel,
  mobile,
  setIsOffscreen = () => undefined,
}) => {
  const ref = useRef();
  const [isCurrentSlide, setIsCurrentSlide] = useState(false);
  const slideParent = ref?.current?.closest('.slick-slide')?.classList?.contains('slick-current') 
  
  useEffect(() => {
    if (
        slideParent
    ) {
      setIsCurrentSlide(true);
    } else {
      setIsCurrentSlide(false);
    }
  }, [isCurrentSlide, slideParent]);

  return (
    <>
      {!mobile ? (
        <div ref={ref} className="grid-wrapper">
          <div className="category-hero-banner__content-wrapper">
            <div className="category-hero-banner__content-container">
              <h1 className="heading-one">{title}</h1>
              {introContent ? (
                <p className="body-one category-hero-banner__intro-content">
                  {introContent}
                </p>
              ) : null}
              {cta ? (
                <div
                  className="category-hero-banner__cta-btn-wrapper"
                  onMouseEnter={() => setIsOffscreen(true)}
                  onMouseLeave={() => setIsOffscreen(false)}
                  onMouseMove={(e) => e.stopPropagation()}
                >
                  <a
                    className="button button--outline category-hero-banner__cta-btn"
                    href={cta?.url}
                    tabIndex={isCurrentSlide ? "0" : "-1"}
                    aria-label={ctaAriaLabel ? ctaAriaLabel : null}
                  >
                    {cta?.title}
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div className="category-hero-banner__content-wrapper category-hero-banner__content-mobile">
          <Container>
            <div className="grid-wrapper">
              <div className="category-hero-banner__content-container">
                <h1 className="heading-one">{title}</h1>
                {introContent ? (
                  <p className="body-one category-hero-banner__intro-content">
                    {introContent}
                  </p>
                ) : null}
                {cta ? (
                  <a
                    className="button button--outline category-hero-banner__cta-btn"
                    href={cta?.url}
                  >
                    {cta?.title}
                  </a>
                ) : null}
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default SliderContent;
